import React from 'react';
import { DeviceUnpairIcon, NewClearAllHistoryIcon } from '../Common/Icons';
import { useUserRole, canShowUnpairAction } from './helpers';
import { getConfirmationMessage } from './DeviceInventoryModal';
import { Tooltip } from 'antd';
import { StatusInfo } from './DeviceInventoryList';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { UNPAIR_DISABLED_MODEL_NAMES } from '@/constants/device';

const MedicalDeviceModalInfo = ({
  device,
  performAction,
  actionsData,
  hubRecord,
  hideModal,
  ConfirmationModal,
  isActionModalVisible,
  activeDeviceAction,
  handleDeviceActionClick,
  deviceStatus,
  timezone,
  loginUserTimeformat,
}) => {
  const userRole = useUserRole();
  const trans = useSelector(translator);
  const allowUnpairAction = canShowUnpairAction(userRole, hubRecord?.rolename);
  const isUnpairDisabled = UNPAIR_DISABLED_MODEL_NAMES.includes(device?.modelname);

  const handleUnpairMedicalDevice = (device) => {
    let data = {
      ...actionsData.unpair_medical_device,
      deviceUuid: hubRecord?.deviceuuid,
    };
    const params =
      actionsData.unpair_medical_device.action === 'perform_unPairAccessories'
        ? {
            params: [
              { name: 'devicemodel', value: device?.modelnumber },
              { name: 'macaddress', value: device?.basemacaddress },
            ],
          }
        : {};
    performAction(data, params);
    hideModal('unpair_medical_device');
  };

  const handleClearAllHistory = (device) => {
    let data = {
      ...actionsData.unpair_medical_device,
      deviceUuid: hubRecord?.deviceuuid,
    };
    performAction(data);
    hideModal('unpair_medical_device');
  };

  return (
    <>
      {allowUnpairAction && device?.paired_status !== 'UNPAIRED' && (
        <div
          className={`device-actions-container ${
            device?.paired_status === 'UNPAIRED' ? 'device-details-transparent' : ''
          }`}
        >
          <div className="device-action-block">
            <div className="device-action-command-description">
              <div className="device-action-label">{trans('ACTIONS')}</div>
              <div className="device-action-description-block">
                {/* <div className="medical-action-description-label">
                  <div className="medical-action-title">
                    {`  “Clear all History”`}
                    <span className="medical-action-desc">{` : clear all data  by clicking on the button`}</span>
                  </div>
                </div> */}
                <div className="medical-action-description-label">
                  <div className="medical-action-title">
                    {trans('“UNPAIR”')}
                    <span className="medical-action-desc">
                      {trans('UNPAIRTHESENSORBYCLICKINGONUNPAIRBUTTON')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="medical-actions-container">
              <Tooltip
                title={
                  deviceStatus === 'disconnected' ? (
                    <StatusInfo
                      lastConnectTime={device?.lastconnecttime}
                      lastDisconnectTime={device?.lastdisconnecttime}
                      device={device}
                      timezone={timezone}
                      loginUserTimeformat={loginUserTimeformat}
                      showDuration={false}
                      tooltipMode={true}
                      trans={trans}
                    />
                  ) : (
                    ''
                  )
                }
              >
                {/* <div
                className="clear-all-history-icon-label"
                onClick={() => handleDeviceActionClick("factory_reset_hc200")}
              >
                <span>
                  <NewClearAllHistoryIcon className="new-factory-reset-icon" />
                </span>
                <div className="unpair-action-label">Clear all History</div>
              </div> */}
                <span>
                  <div
                    className={`device-action-icon-label ${
                      deviceStatus === 'disconnected' || isUnpairDisabled
                        ? 'device-page-actions-disabled'
                        : ''
                    }`}
                    onClick={() =>
                      deviceStatus !== 'disconnected' &&
                      !isUnpairDisabled &&
                      handleDeviceActionClick('unpair_medical_device')
                    }
                  >
                    <DeviceUnpairIcon
                      className="unpair-icon"
                      strokeColor={
                        deviceStatus === 'disconnected' || isUnpairDisabled ? '#808080' : '#005d98'
                      }
                      fillColor={
                        deviceStatus === 'disconnected' || isUnpairDisabled ? '#808080' : '#0072BC'
                      }
                    />
                    <div className="unpair-action-label">{trans('UNPAIR')}</div>
                  </div>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      )}

      <ConfirmationModal
        visible={isActionModalVisible[activeDeviceAction]}
        title={
          <span className="custom-modal-title">
            {getConfirmationMessage(actionsData[activeDeviceAction]?.title?.toLowerCase(), trans)}
          </span>
        }
        description={actionsData[activeDeviceAction]?.description}
        onConfirm={() =>
          activeDeviceAction === 'unpair_medical_device'
            ? handleUnpairMedicalDevice(device)
            : handleClearAllHistory(device)
        }
        onCancel={() => hideModal(activeDeviceAction)}
        customLabel={actionsData[activeDeviceAction]?.title}
        customIcon={
          activeDeviceAction === 'unpair_medical_device' ? (
            <DeviceUnpairIcon fillColor="#113E57" strokeColor="#113E57" />
          ) : (
            <NewClearAllHistoryIcon />
          )
        }
        activeDeviceAction={activeDeviceAction}
      />
    </>
  );
};

export default MedicalDeviceModalInfo;
